Listing.customCallbacks.beforeFetch = () => {
    rEvent.dispatch('Listing.customBeforeFetch');
}

rEvent.on('Listing.customBeforeFetch', function() {
    if ($('.c-listing').length) {
        $('.c-listing').addClass('is-loading');
    }
});

rEvent.on('Listing.fetchedData', function (data) {
    requestAnimationFrame(() => {
        if ($('.c-listing').length) {
            $('.c-listing').removeClass('is-loading');
        }

        if ($('.pager__load').length) {
            $('.pager__load').removeClass('is-loading');
        }
    })
});

$(function () {
    $(document).on('click', '.pager__list a', function(event) {
        event.preventDefault();

        $.get($(this).attr('href'), {}, function(data) {
            Listing.callbacks.update(data);
        }, 'json');

        $(this).addClass('is-loading');

        if ($('.c-listing').length) {
            $('.c-listing').addClass('is-loading');
        }
    });

    $(document).on('click', '.pager__load', function(event) {
        $(this).addClass('is-loading');
    });

    $('.js-form-contact').validate({
        rules: {
            'name': {
                minlength: 3
            },
            'message': {
                minlength: 5
            }
        },
        errorPlacement: function(error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            Form.ajaxPost(form, function(data) {
                var msg = data.msg.format;

                if (!msg) {
                    msg = data.msg;
                }

                $('.js-contact-error').hide();

                if (!data.status) {
                    $('.js-contact-error')
                        .text(msg)
                        .slideDown();
                } else {
                    $(form).slideUp(250, function(){
                        $('.js-contact-success')
                            .text(msg)
                            .slideDown(250);
                    });
                }

                rEvent.dispatch('Recaptcha.execute');
            }, "json");
        }
    });
});
